var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/blurhash.tsx";
const _excluded = ["hash", "width", "height", "dummy"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { decode } from 'blurhash';
import React, { useRef, useEffect } from 'react';
/**
 * Renders a blurhash in a canvas element.
 * @see {@link https://blurha.sh/}
 */
const Blurhash = _ref => {
  let {
      hash,
      width = 32,
      height = width,
      dummy = false
    } = _ref,
    canvasProps = _objectWithoutProperties(_ref, _excluded);
  const canvasRef = useRef(null);
  useEffect(() => {
    const {
      current: canvas
    } = canvasRef;
    if (!canvas) return;

    // resets canvas
    canvas.width = canvas.width; // eslint-disable-line no-self-assign

    if (dummy || !hash) return;
    try {
      const pixels = decode(hash, width, height);
      const ctx = canvas.getContext('2d');
      const imageData = new ImageData(pixels, width, height);
      if (!ctx) return;
      ctx.putImageData(imageData, 0, 0);
    } catch (err) {
      console.error('Blurhash decoding failure', {
        err,
        hash
      });
    }
  }, [dummy, hash, width, height]);
  return /*#__PURE__*/React.createElement("canvas", _extends({}, canvasProps, {
    ref: canvasRef,
    width: width,
    height: height,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 5
    }
  }));
};
export default /*#__PURE__*/React.memo(Blurhash);